// split.io
export const LAUNCH_LOCATION_TARGETING = 'launch_location_targeting';

// statsig
export const LOCATION_TARGETING_STATSIG_EXPERIMENT = 'location_targeting';
export const RENDER_LOCATION_TARGETING = 'should_render_ui_changes';

// TODO This should be false, but we're temporarily setting it to true to always render the feature if split.io is enabled.
export const RENDER_LOCATION_TARGETING_DEFAULT = false;
